<ng-container *transloco="let t">
  @let currentStep = currentStep$ | async;
  @if (picture) {
    @switch (currentStep) {
      @case (WoundtrackStep.WOUNDSIZE) {
        @let isLoading = isWoundsizeLoading$ | async;
        <pxc-studio
          [config]="woundsizeStudioConfig"
          [disabled]="isLoading"
          [imageSrc]="picture.source"
          [topBarConfig]="woundsizeBarConfig">
          @if (isLoading) {
            <pxc-scan-loader>
              {{ t('Analyse dimensionnelle en cours ...') }}
            </pxc-scan-loader>
          }
        </pxc-studio>
      }
      @case (WoundtrackStep.WOUNDTYPE) {
        @let isLoading = isWoundtypeLoading$ | async;
        <pxc-studio
          [config]="woundtypeStudioConfig"
          [disabled]="isLoading"
          [imageSrc]="picture.source"
          [topBarConfig]="woundtypeBarConfig">
          @if (isLoading) {
            <pxc-scan-loader>
              {{ t('Analyse tissulaire en cours ...') }}
            </pxc-scan-loader>
          }
        </pxc-studio>
      }
    }
    <pxc-compliance-logo class="absolute right-4 bottom-4 h-5" [targetModuleId]="targetModuleId" />
  }

  @let woundsizeResultItems = woundsizeResultItems$ | async;
  @let woundtypeResultItems = woundtypeResultItems$ | async;
  <div class="absolute right-0 top-16">
    <div class="flex flex-col gap-4 p-4 pb-16" id="woundtrackResults">
      @if (woundsizeResultItems?.length) {
        <div
          appearance="outline"
          class="max-w-sm p-0! shadow-xl! animate-in fade-in slide-in-from-right-8"
          tuiCardLarge="">
          <pxc-module-result [items]="woundsizeResultItems" [title]="t('Dimensions')" />
        </div>
      }

      @if (woundtypeResultItems?.length) {
        <div
          appearance="outline"
          class="max-w-sm p-0! shadow-xl! animate-in fade-in slide-in-from-right-8"
          tuiCardLarge="">
          <pxc-module-result [items]="woundtypeResultItems" [title]="t('Tissus')" />
        </div>
      }
    </div>
  </div>
</ng-container>
